/** The five Kindness Sparks families, each with one simple line icon from
 *  @hackclub/icons. Shared by the "Add a New Spark" category picker and the
 *  cards built from the Kindness Sparks API, so a family always looks the same. */
export const SPARK_FAMILIES = [
  { key: "connection", label: "Connection", icon: "link" },
  { key: "family", label: "Family", icon: "home" },
  { key: "wellbeing", label: "Wellbeing", icon: "like" },
  { key: "community", label: "Community", icon: "people-3" },
  { key: "stewardship", label: "Stewardship", icon: "houseplant" },
] as const;

export type SparkFamilyLabel = (typeof SPARK_FAMILIES)[number]["label"];

/** Icon for an API family string ("community", "Wellbeing", …); bolt if unknown. */
export function familyIcon(family: string): string {
  const key = family.trim().toLowerCase();
  return SPARK_FAMILIES.find((f) => f.key === key)?.icon ?? "bolt";
}
